import {
    useCallback,
    useContext,
    useState,
    useEffect,
} from 'react';
import Raven from 'raven-js';

import { BasketContext } from '../BasketProvider';


export const useButtonOptimisticState = (
    id,
    portion,
    dishCountStep,
    trackAddToBasket,
) => {
    const { updateBasket } = useContext(BasketContext);

    const [isDishInBasket, setIsDishInBasket] = useState(portion > 0);

    useEffect(() => {
        setIsDishInBasket(portion > 0);
    }, [portion]);

    const handleAddToBasket = useCallback((e) => {
        e.stopPropagation();
        setIsDishInBasket(true);
        try {
            trackAddToBasket({ id, portions: dishCountStep });
            updateBasket({ dishId: id, portions: dishCountStep });
        } catch (error) {
            Raven.captureException(error);
            setIsDishInBasket(false);
        }
    }, [trackAddToBasket, updateBasket, dishCountStep, id, setIsDishInBasket]);

    return {
        isDishInBasket,
        handleAddToBasket,
    };
};
